import { cn } from '@/lib/cn'

/**
 * The look of a selectable chip-like control — a tab, a segment, a date preset (design §6.12,
 * decision D1). Selected is the FilterChip formula: the cyan tint, the cyan line and ink-1 600;
 * the rest are neutral (surface-3, hairline-strong, ink-2 500). The solid cyan fill is reserved
 * for the one primary action of a screen, so a row of tabs no longer competes with «Сохранить».
 * The selected state is never colour only: the line, the weight and the caller's glyph (✓ on a
 * pressed segment) carry it too (rule 21).
 *
 * `sm` is 32 px (tabs, toolbars), `md` 40 px (a FilterBar row, next to `Input size="sm"`).
 * On a touch screen both grow to 44 px.
 */
export function toggleClass(selected: boolean, size: 'sm' | 'md' = 'sm'): string {
  return cn(
    'inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-sm border',
    'transition-colors duration-micro ease active:scale-[0.98]',
    '[@media(pointer:coarse)]:min-h-11',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan',
    'disabled:pointer-events-none disabled:border-hairline disabled:bg-surface-3 disabled:text-ink-3',
    size === 'md' ? 'h-10 px-4 text-body' : 'h-8 px-3 text-caption',
    selected
      ? 'border-cyan bg-cyan-soft font-semibold text-ink-1'
      : 'border-hairline-strong bg-surface-3 font-medium text-ink-2 hover:border-field hover:text-ink-1',
  )
}
